import React, {Component} from 'react';
import {Label, List} from 'semantic-ui-react';
import {ticketCheckModal} from "../../actions/TicketCheckActions";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import {selectTicket} from "../../actions/TicketSelectActions";

class ProductsTicket extends Component{

    handleClick = (ticket, code, id) => {
        this.props.ticketCheckModal({open:true, ticket, code, id});
    };

    render(){
        return <List divided relaxed>
            {this.props.products.map(product_ticket => {
                return <List.Item key={product_ticket.id}>
                    <List.Content>
                        <Label as='a' color={product_ticket.checked < product_ticket.quantity ? 'orange':null} onClick={() => this.handleClick(product_ticket, this.props.code, this.props.id)}>
                            {product_ticket.product.name} - {product_ticket.checked} de {product_ticket.quantity}
                        </Label>
                    </List.Content>
                </List.Item>
            })}
        </List>
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ticketCheckModal(data){
            dispatch(ticketCheckModal(data))
        },
        selectTicket(data){
            dispatch(selectTicket(data))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(withRouter(ProductsTicket));


// WEBPACK FOOTER //
// ./src/components/services/ProductsTicket.js